import WebAPIUtils from "utils/Global/WebApiUtils";

module.exports = {
  getSSOEntryPoint: (domain, cb) => {
    WebAPIUtils.getSSOEntryPoint(domain, result => {
      cb(result);
    });
  }
};
